import actions from './actions';
import types from './mutation-types';
import { isNil } from 'lodash';

const state = {
	fetch: {
		isFetching: false,
		error: null
	},
	create: {
		isCreating: false,
		error: null
	},
	update: {
		isUpdating: false,
		error: null
	},
	delete: {
		isDeleting: false,
		error: null
	},
	bid: {},
	bidNumbers: {},
	item: false
};

const getters = {
	bid: state => state.bid,
	item: state => state.item,
	bidNumbers: state => state.bidNumbers,
	isFetching: state => state.fetch.isFetching,
	isCreating: state => state.create.isCreating,
	isUpdating: state => state.update.isUpdating,
	isDeleting: state => state.delete.isDeleting,
	deleteError: state => state.delete.error,
	formError: state => {
		if (state.fetch.error) return state.fetch.error;
		if (state.update.error) return state.update.error;
		if (state.create.error) return state.create.error;
		return {};
	}
};

const mutations = {
	[types.FETCH_BID_START](state) {
		state.fetch.isFetching = true;
		state.fetch.error = null;
	},
	[types.FETCH_BID_SUCCESS](state, payload) {
		state.fetch.isFetching = false;
		state.bid = payload;
		state.item = payload.item;
	},
	[types.FETCH_BID_ERROR](state, payload) {
		state.fetch.isFetching = false;
		state.fetch.error = payload;
	},
	[types.FETCH_ITEM_START](state) {
		state.fetch.isFetching = true;
		state.fetch.error = null;
	},
	[types.FETCH_ITEM_SUCCESS](state, payload) {
		state.fetch.isFetching = false;
		state.item = payload;
	},
	[types.FETCH_ITEM_ERROR](state, payload) {
		state.fetch.isFetching = false;
		state.fetch.error = payload;
	},
	[types.CREATE_BID_START](state) {
		state.create.isCreating = true;
		state.create.error = null;
	},
	[types.CREATE_BID_SUCCESS](state, payload) {
		state.create.isCreating = false;
		state.bid = payload;
		state.item = payload.item;
	},
	[types.CREATE_BID_ERROR](state, payload) {
		state.create.isCreating = false;
		state.create.error = payload;
	},
	[types.UPDATE_BID_START](state) {
		state.update.isUpdating = true;
		state.update.error = null;
	},
	[types.UPDATE_BID_SUCCESS](state, payload) {
		state.update.isUpdating = false;
		state.bid = payload;
	},
	[types.UPDATE_BID_ERROR](state, payload) {
		state.update.isUpdating = false;
		state.update.error = payload;
	},
	[types.DELETE_BID_START](state) {
		state.delete.isDeleting = true;
		state.delete.error = null;
	},
	[types.DELETE_BID_SUCCESS](state) {
		state.delete.isDeleting = false;
		state.bid = {};
	},
	[types.DELETE_BID_ERROR](state, payload) {
		state.delete.isDeleting = false;
		state.delete.error = payload;
	},
	[types.FETCH_BID_NUMBERS_START](state) {
		state.fetch.isFetching = true;
		state.fetch.error = null;
	},
	[types.FETCH_BID_NUMBERS_ERROR](state, payload) {
		state.fetch.isFetching = false;
		state.fetch.error = payload;
	},
	[types.FETCH_BID_NUMBERS_SUCCESS](state, payload) {
		state.fetch.isFetching = false;
		state.bidNumbers = payload;
	},
	[types.RESET_ALL](state) {
		state.bid = {};
		state.bidNumbers = {};
		state.delete.error = null;
		state.update.error = null;
		state.fetch.error = null;
	}
};

export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/pending-bid-form/index.js